<template>
  <v-app>
    <div v-if="!online" class="pwa-notice" role="status">
      <span class="notice-bar" aria-hidden="true"></span>
      <span class="notice-text">آفلاین هستید؛ اطلاعات تازه پس از اتصال بارگذاری می‌شود.</span>
    </div>
    <div v-if="updateAvailable" class="pwa-notice is-update" role="status">
      <span class="notice-bar" aria-hidden="true"></span>
      <span class="notice-text">نسخه‌ی تازه‌ی وینو آماده است.</span>
      <button type="button" :disabled="updating" @click="reload">{{ updating ? 'در حال به‌روزرسانی…' : 'به‌روزرسانی' }}</button>
    </div>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data() { return { online: navigator.onLine, updateAvailable: false, updateRegistration: null, updating: false }; },
  mounted() {
    window.addEventListener('online', this.setOnline);
    window.addEventListener('offline', this.setOffline);
    window.addEventListener('vino:pwa-update', this.showUpdate);
  },
  beforeDestroy() {
    window.removeEventListener('online', this.setOnline);
    window.removeEventListener('offline', this.setOffline);
    window.removeEventListener('vino:pwa-update', this.showUpdate);
  },
  methods: {
    setOnline() { this.online = true; },
    setOffline() { this.online = false; },
    showUpdate(event) {
      this.updateRegistration = event.detail && event.detail.registration;
      this.updateAvailable = true;
    },
    reload() {
      if (this.updating) return;
      const waiting = this.updateRegistration && this.updateRegistration.waiting;
      if (!waiting || !navigator.serviceWorker) {
        window.location.reload();
        return;
      }
      this.updating = true;
      navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), { once: true });
      waiting.postMessage({ type: 'SKIP_WAITING' });
    },
  },
};
</script>
<style>
#app { background: var(--background-primary); min-height: 100vh; position: relative; }
.v-application { background: transparent !important; font-family: var(--font) !important; }
.v-application .v-btn { border-radius: var(--radius-sm) !important; text-transform: none !important; }
.v-application .v-card { border-radius: var(--radius-lg) !important; }

/* status strip above everything: pink for offline (signal), amber for a pending update (data) */
.pwa-notice { position: fixed; top: 0; inset-inline: 0; z-index: 20; max-width: 576px; margin: 0 auto; display: flex; align-items: center; gap: 10px; padding: calc(8px + env(safe-area-inset-top)) 16px 8px; background: var(--navy-950); color: #fff; font-size: 12.5px; line-height: 1.6; box-shadow: 0 1px 0 var(--shell-line); }
.notice-bar { width: 10px; height: 18px; flex: none; background: var(--pink-500); transform: skewX(var(--slant)); }
.is-update .notice-bar { background: var(--amber-500); }
.notice-text { flex: 1; }
.pwa-notice button { min-height: 36px; padding: 0 12px; border: 0; border-radius: var(--radius-sm); background: var(--amber-500); color: var(--navy-900); font-weight: 900; }
.pwa-notice button:disabled { opacity: .7; }
</style>
